module.exports = __webpack_public_path__ + "img/google.5ab31802.svg";